(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-footer"] && !Shopify.designMode) return;
  try {
    
  /**
   * Footer columns render open so they survive a JS failure. Below the
   * breakpoint the brief wants accordions, so collapse them there — and
   * reopen on the way back up, since a closed <details> would otherwise
   * hide a whole column on desktop.
   */
  (() => {
    const query = window.matchMedia('(max-width: 749px)');
    const columns = document.querySelectorAll('[data-mr-footer-col]');
    if (!columns.length) return;

    const apply = () => {
      columns.forEach((column) => {
        column.open = !query.matches;
      });
    };

    apply();
    query.addEventListener('change', apply);
  })();

  } catch(e) { console.error(e); }
})();
})();
